import { Injectable } from '@angular/core';
import { timer, Subject, Observable } from 'rxjs';
import { takeWhile, map } from 'rxjs/operators';

@Injectable()
export class CountdownService {
    private _countdown: Subject<number>;
    private counter$: any;
    private isCounting: boolean;
    constructor() {
        this._countdown = new Subject<number>();
    }

    countdown(): Observable<number> {
        return this._countdown.asObservable();
    }

    start(count: number): void {
        // Ensure that only one timer is in progress at any given time.
        this.isCounting = false;
        const countTimer = count;
        if (!this.isCounting) {
            this.isCounting = true;
            if (this.counter$) {
                this.counter$.unsubscribe();
            }
            this.counter$ = timer(0, 1000)
                .pipe(
                    takeWhile((t) => t < countTimer),
                    map((t) => countTimer - t)
                    // tslint:disable-next-line: deprecation
                )
                .subscribe({
                    next: (t) => this._countdown.next(t),
                    complete: () => {
                        this._countdown.complete();
                        this.isCounting = false;
                        // Reset the countdown Subject so that a
                        // countdown can be performed more than once.
                        this.counter$.unsubscribe();
                        this._countdown = new Subject<number>();
                    }
                });
        }
    }
    
    stop(): void {
        if (this.counter$) {
            this.counter$.unsubscribe();
            this._countdown = new Subject<number>();
        }
    }
}
